import React from 'react'
import { bool, number, string } from 'prop-types'
import shave from 'shave'
import Markdown from 'markdown-to-jsx'
import Dotdotdot from 'react-dotdotdot'

export default class Ellipsis extends React.Component {
  componentDidMount() {
    setTimeout(() => { this.shave() }, 500)
  }

  componentDidUpdate() {
    this.shave()
  }

  shave() {
    if (this.box) {
      shave(this.box, this.props.height)
    }
  }

  render() {
    const { component: Component, markdown, clamp } = this.props
    if (markdown) {
      const useNativeClamp = true
      return (
        <div className={this.props.className}>
          <Dotdotdot clamp={clamp} useNativeClamp={useNativeClamp}>
            <Markdown options={{ forceInline: true }}>
              {this.props.text || ''}
            </Markdown>
          </Dotdotdot>
        </div>
      )
    }
    return (
      <Component ref={(c) => { this.box = c }} className={this.props.className}>
        {this.props.text}
      </Component>
    )
  }
}

Ellipsis.propTypes = {
  text: string.isRequired,
  height: number,
  component: string,
  className: string,
  markdown: bool,
  clamp: number,
}

Ellipsis.defaultProps = {
  component: 'p',
  clamp: 3,
}
